// src/equalArrayBuffers.ts
var equalArrayBuffers = (a1, a2) => {
  const u1 = new Uint8Array(a1);
  const u2 = new Uint8Array(a2);
  if (u1.byteLength !== u2.byteLength) return false;
  for (let i = 0; i < u1.byteLength; i++) {
    if (u1[i] !== u2[i]) return false;
  }
  return true;
};

// src/isArrayBuffer.ts
function isArrayBuffer(value) {
  return value instanceof ArrayBuffer;
}
function isArrayBufferLike(value) {
  return value !== null && typeof value === "object" && "byteLength" in value && typeof value.byteLength === "number" && "slice" in value && typeof value.slice === "function";
}

// src/toArrayBuffer.ts
import { assertEx } from "@xylabs/assert";
import { toHex } from "@xylabs/hex";
import { isUndefined } from "@xylabs/typeof";
function hexToArrayBuffer(value) {
  if (value.length % 2 !== 0) {
    throw new Error("Invalid hex value");
  }
  const length = value.length / 2;
  const result = new Uint8Array(new ArrayBuffer(length));
  for (let i = 0; i < length; i++) {
    const byte = value.slice(i * 2, i * 2 + 2);
    result[i] = Number.parseInt(byte, 16);
  }
  return result;
}
function stringToArrayBuffer(value, base = 16) {
  switch (base) {
    case 16: {
      return hexToArrayBuffer(toHex((value.startsWith("0x") ? value.slice(2) : value).toUpperCase()));
    }
    default: {
      throw new Error(`Unsupported base [${base}]`);
    }
  }
}
function toArrayBuffer(value, padLength = 0, base) {
  if (isUndefined(value)) return void 0;
  if (typeof value === "bigint" && value < 0) {
    throw new Error(`negative bigint values are not supported: ${typeof value}`);
  }
  let result = typeof value === "string" ? stringToArrayBuffer(value, base) : typeof value === "bigint" ? stringToArrayBuffer(value.toString(16)) : new Uint8Array(value);
  if (result === void 0) {
    throw new Error(`toArrayBuffer - Unknown type: ${typeof value}`);
  }
  if (result.length < padLength) {
    result = new Uint8Array([...new Uint8Array(padLength - result.length), ...result]);
    assertEx(result?.length <= padLength, () => "Resulting length is greater than padLength");
  }
  return result.buffer;
}

// src/toUint8Array.ts
function toUint8Array(value, padLength, base) {
  const arrayBuffer = toArrayBuffer(value, padLength, base);
  return arrayBuffer ? new Uint8Array(arrayBuffer) : void 0;
}
export {
  equalArrayBuffers,
  isArrayBuffer,
  isArrayBufferLike,
  toArrayBuffer,
  toUint8Array
};
//# sourceMappingURL=index.mjs.map